<div class="listerContainer">
  <div class="header">
    <div class="d-flex mb-3">
      <h1>{{ listerAvisMessages.titles | translate }}</h1>
      <div class="ml-auto">
        <app-bottom-page></app-bottom-page>
      </div>
      <button *ngIf="hasManageRight" [disabled]="isLoading" [routerLink]="'/avisdepublicite/creerAvisPub'" class="btn btn-primary">{{
          listerAvisMessages.creerAP | translate
        }}
      </button>
    </div>
    <div class="statut-filter d-flex mb-3 statut-filter" *ngIf="!isLoading">
      <button class="btn btn-light btn-filter-disabled shadow-none" *ngFor="let button of buttons; let  i = index"
              class="btn" (click)="setAvisStatusFilter(i)"
              [ngClass]="{'btn-filter-disabled': !button.active ,'btn-filter-enabled' : button.active , 'btn-light': !button.active ,'btn-primary' : button.active }">{{ button.value }}
      </button>
    </div>
  </div>
  <div [hidden]="isLoading">
    <app-tableau [tableContent]="tableContent" (actionEvent)="getActionEvent($event)" [sortingColumn]="sortingColumn"
                 [totalItems]="totalItems" [statutCode]="choosenStatus" [enableFilter]="enableFilter"
                 (sortColumnChangeEmiter)="changeSortColumnEvent($event)">
    </app-tableau>
    <div class="line">
      <div class="ml-auto">
        <app-top-table-page></app-top-table-page>
      </div>
    </div>
  </div>
</div>
